import Vue from 'vue';
import VueI18n from 'vue-i18n';

import en from '../../locales/en.json';
import es from '../../locales/es.json';
import ko from '../../locales/ko.json';
import ru from '../../locales/ru.json';
import zh from '../../locales/zh.json';
import vi from '../../locales/vi.json';
import pt from '../../locales/pt.json';
import ht from '../../locales/ht.json';

Vue.use(VueI18n);



let locale = 'en';
// read lang from local storage if it exists
if (window && window.localStorage) {
  locale = window.localStorage.getItem('ppt_locale') || 'en';
}

export default new VueI18n({
  locale,
  fallbackLocale: 'en',
  messages: {
    en,
    es,
    ko,
    ru,
    zh,
    vi,
    pt,
    ht
  }
});